<template>

    <div class="menuHolder">

         <transition
      appearname="MenuUnlock"
      enter-active-class="animated fadeIn"
      leave-active-class="animated fadeOut"
      v-on:after-leave="clickHandler"
    >
    <div id='prize_holder'>
      <div id='top'></div>
        <div id='center'>
         <div></div>
         <div id='rowHolder'>
            <div id='box1'>
              <div id='box1' class ='tablerow'>
                <div class='test_img bg_right animated jackInTheBox' v-on:click="clickHandler(0)" :style="backgroundStyle.backgroundStyleImg1" v-if="day1 === 'unlock'"></div>
                <div class='test_img bg_left animated jackInTheBox delay-02s' v-on:click="clickHandler(1)" :style="backgroundStyle.backgroundStyleImg2" v-if="day2 === 'unlock'"></div>

                <div class='test_img bg_right animated jackInTheBox' :style="backgroundStyle.backgroundStyleImg1_lock" v-if="day1 === 'lock'"></div>
                <div class='test_img bg_left animated jackInTheBox delay-02s' :style="backgroundStyle.backgroundStyleImg2_lock" v-if="day2 === 'lock'"></div>
              </div>
            </div>
           <div id='box2'>
               <div id='box2' class ='tablerow'>
                   <div class='test_img bg_right animated jackInTheBox delay-03s' v-on:click="clickHandler(2)"  :style="backgroundStyle.backgroundStyleImg3" v-if="day3 === 'unlock'"></div>
                <div class='test_img bg_center animated jackInTheBox delay-04s' v-on:click="clickHandler(3)"  :style="backgroundStyle.backgroundStyleImg4" v-if="day4 === 'unlock'"></div>
                <div class='test_img bg_left animated jackInTheBox delay-05s' v-on:click="clickHandler(4)"  :style="backgroundStyle.backgroundStyleImg5" v-if="day5 === 'unlock'"></div>

                <div class='test_img bg_right animated jackInTheBox delay-03s' :style="backgroundStyle.backgroundStyleImg3_lock" v-if="day3 === 'lock'"></div>
                 <div class='test_img bg_center animated jackInTheBox delay-04s' :style="backgroundStyle.backgroundStyleImg4_lock" v-if="day4 === 'lock'"></div>
                <div class='test_img bg_left animated jackInTheBox delay-05s' :style="backgroundStyle.backgroundStyleImg5_lock" v-if="day5 === 'lock'"></div>
              </div>
          </div>
           <div id='box3'>
              <div id='box3' class ='tablerow'>
                <div class='test_img bg_right animated jackInTheBox delay-06s' v-on:click="clickHandler(5)"  :style="backgroundStyle.backgroundStyleImg6" v-if="day6 === 'unlock'"></div>
                <div class='test_img bg_left animated jackInTheBox delay-07s' v-on:click="clickHandler(6)"  :style="backgroundStyle.backgroundStyleImg7" v-if="day7 === 'unlock'"></div>

                <div class='test_img bg_right animated jackInTheBox delay-06s' :style="backgroundStyle.backgroundStyleImg6_lock" v-if="day6 === 'lock'"></div>
                <div class='test_img bg_left animated jackInTheBox delay-07s' :style="backgroundStyle.backgroundStyleImg7_lock" v-if="day7 === 'lock'"></div>
              </div>
          </div>
          </div>
        </div>
      <div id='bottom'></div>
    </div>
      </transition>
  
    </div>

</template>

<script>
/* eslint-disable */
import { eventBus } from '../EventBus';


let backgroundStyleImgONE = 'static/results/menu/sticker_day1.png';
let backgroundStyleImgTWO = 'static/results/menu/sticker_day2.png';
let backgroundStyleImgTHREE = 'static/results/menu/sticker_day3.png';
let backgroundStyleImgFOUR = 'static/results/menu/sticker_day4.png';
let backgroundStyleImgFIVE = 'static/results/menu/sticker_day5.png';
let backgroundStyleImgSIX = 'static/results/menu/sticker_day6.png';
let backgroundStyleImgSEVEN = 'static/results/menu/sticker_day7.png';

let backgroundStyleImgONELOCK = 'static/images/menu/dec_26.png';
let backgroundStyleImgTWOLOCK = 'static/images/menu/dec_27.png';
let backgroundStyleImgTHREELOCK = 'static/images/menu/dec_28.png';
let backgroundStyleImgFOURLOCK = 'static/images/menu/dec_29.png';
let backgroundStyleImgFIVELOCK = 'static/images/menu/dec_30.png';
let backgroundStyleImgSIXLOCK = 'static/images/menu/dec_31.png';
let backgroundStyleImgSEVENLOCK = 'static/images/menu/jan_1.png';

export default {
   created() {
      this.dateSwap();
   },
   data() {
    return {
      show: true,
      quizStarting: false,
      showRotate:false,
      answerValue:0,
      day1:'lock',
      day2:'lock',
      day3:'lock',
      day4:'lock',
      day5:'lock',
      day6:'lock',
      day7:'lock',
      backgroundStyle: {
        backgroundStyleImg1: {
          'background-image': "url('" + backgroundStyleImgONE + "')"
        },
          backgroundStyleImg2: {
          'background-image': "url('" + backgroundStyleImgTWO + "')"
        },
         backgroundStyleImg3: {
          'background-image': "url('" + backgroundStyleImgTHREE + "')"
        },
         backgroundStyleImg4: {
          'background-image': "url('" + backgroundStyleImgFOUR + "')"
        },
         backgroundStyleImg5: {
          'background-image': "url('" + backgroundStyleImgFIVE + "')"
        },
         backgroundStyleImg6: {
          'background-image': "url('" + backgroundStyleImgSIX + "')"
        },
         backgroundStyleImg7: {
          'background-image': "url('" + backgroundStyleImgSEVEN + "')"
        },
         backgroundStyleImg1_lock: {
          'background-image': "url('" + backgroundStyleImgONELOCK + "')"
        },
        backgroundStyleImg2_lock: {
          'background-image': "url('" + backgroundStyleImgTWOLOCK + "')"
        },
         backgroundStyleImg3_lock: {
          'background-image': "url('" + backgroundStyleImgTHREELOCK + "')"
        },
         backgroundStyleImg4_lock: {
          'background-image': "url('" + backgroundStyleImgFOURLOCK + "')"
        },
         backgroundStyleImg5_lock: {
          'background-image': "url('" + backgroundStyleImgFIVELOCK + "')"
        },
         backgroundStyleImg6_lock: {
          'background-image': "url('" + backgroundStyleImgSIXLOCK + "')"
        },
         backgroundStyleImg7_lock: {
          'background-image': "url('" + backgroundStyleImgSEVENLOCK + "')"
        },
      }
    };
  },
  methods: {
    clickHandler(value) {
    
      this.answerValue = value;
       eventBus.answerSelected(this.answerValue); 
    },
    dateSwap: function() {
        var d0 = new Date('12/26/2019 00:00:00').getTime();
        var d1 = new Date('12/27/2019 00:00:00').getTime();
        var d2 = new Date('12/28/2019 00:00:00').getTime();
        var d3 = new Date('12/29/2019 00:00:00').getTime();
        var d4 = new Date('12/30/2019 00:00:00').getTime();
        var d5 = new Date('12/31/2019 00:00:00').getTime();
        var d6 = new Date('01/01/2020 00:00:00').getTime();

        var now = new Date().getTime();

        if (now >= d6){
          console.log('jan1');
          this.day7 = 'unlock';
          this.day6 = 'unlock';
          this.day5 = 'unlock';
          this.day4 = 'unlock';
          this.day3 = 'unlock';
          this.day2 = 'unlock';
          this.day1 = 'unlock';
        } 
        else if (now >= d5 && now < d6){
          console.log('dec31');
          this.day7 = 'lock';
          this.day6 = 'unlock';
          this.day5 = 'unlock';
          this.day4 = 'unlock';
          this.day3 = 'unlock';
          this.day2 = 'unlock';
          this.day1 = 'unlock';
        }
        else if (now >= d4 && now < d5){
          console.log('dec30');
          this.day7 = 'lock';
          this.day6 = 'lock';
          this.day5 = 'unlock';
          this.day4 = 'unlock';
          this.day3 = 'unlock';
          this.day2 = 'unlock';
          this.day1 = 'unlock';
        }
        else if (now >= d3 && now < d4){
          console.log('dec29');
          this.day7 = 'lock';
          this.day6 = 'lock';
          this.day5 = 'lock';
          this.day4 = 'unlock';
          this.day3 = 'unlock';
          this.day2 = 'unlock';
          this.day1 = 'unlock';
        }
        else if (now >= d2 && now < d3){
          console.log('dec28');
          this.day7 = 'lock';
          this.day6 = 'lock';
          this.day5 = 'lock';
          this.day4 = 'lock';
          this.day3 = 'unlock';
          this.day2 = 'unlock';
          this.day1 = 'unlock';
        }
        else if (now >= d1 && now < d2){
          console.log('dec27');
          this.day7 = 'lock';
          this.day6 = 'lock';
          this.day5 = 'lock';
          this.day4 = 'lock';
          this.day3 = 'lock';
          this.day2 = 'unlock';
          this.day1 = 'unlock';
        }
        else {
          console.log('dec26');
          this.day7 = 'lock';
          this.day6 = 'lock';
          this.day5 = 'lock';
          this.day4 = 'lock';
          this.day3 = 'lock';
          this.day2 = 'lock';
          this.day1 = 'unlock';
        }
        
    }

  }
}


</script>

<style lang="scss">

// Media Query Breakpoints
$break-phone-s: only screen (max-height: 600px); //iphone 6 below
$break-phone-m: only screen and (max-height: 740px) ; //pixel2, iphone7plus
$break-phone-l: only screen and (min-height: 741px); //pixel2 XL, iphoneX

 .test_img{
        top: 0;
        width: 85%;
        height:85%;
        /* position:absolute; */
        background-repeat: no-repeat;
        background-size: contain;
      }

.menuHolder{
  width:100%;
  height:100%;
  /* background:black; */
  position:absolute;
  z-index:10;
}

#prize_holder{
    width:100%;
    height:100%;

    display: grid;
    grid-template-rows: 12% 76% 12%;
    justify-items: center;

    @media #{$break-phone-m} {
        grid-template-rows: 15% 70% 15%;
      }

     grid-template-areas: 
    "header"
    "copy-holder"
    "footer";

}

#center {
  width:100%;
  height:100%;
  display:grid;
  grid-template-rows: 25% 75%;
  justify-items: center;
}

#rowHolder{
  width:100%;
    height:100%;

    display: grid;
    grid-template-rows: 33% 33% 33% 1%;
    justify-items: center;
    grid-template-areas: 
    "top_container"
    "mid_container"
    "bottom_container"
    "non-footer";

    overflow:none;
}

.tablerow{
    width:100%;
    height:100%;
    top:0px;
    left:0px;
    display:flex;
    position:absolute;
  }

#box1{
  grid-area:top_container;
  display:flex;
  width:100%;
  height:100%;
  position:relative;

}

#box2{
  grid-area:mid_container;
  display:flex;
  width:100%;
  height:100%;
  position:relative;
}

#box3{
  grid-area:bottom_container;
  display:flex;
  width:100%;
  height:100%;
  position:relative;
}

.bg_left{
    background-position: top left;
    margin-left:10px;
}

.bg_right{
    background-position: top right;
    margin-right:10px;
}

.bg_center{
    background-position: top center;
    margin-right:10px;
    margin-left:10px;
}
</style>
             


// WEBPACK FOOTER //
// src/components/MenuUnlock.vue